import React, { useState, useEffect } from "react";
import PageServices from "../../services/PageServices";
import { Link, useNavigate } from "react-router-dom";

function HotOption() {
  const [data, setData] = useState([]);
  const [support, setSupport] = useState(null);
  const [resistance, setResistance] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [date, setDate] = useState(""); // State for the selected date
  const navigate = useNavigate();

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };
console.log(date)

  useEffect(() => {
    if (date) { // Ensure date is not empty
      PageServices.getHotOptionData()
        .then((response) => {
          console.log("API Response:", response?.data);
          setData(response?.data || []); // Ensure data is an array

          if (Array.isArray(response?.data)) {
            let supportData = null;
            let resistanceData = null;

            response.data.forEach((item) => {
              if (item?.resistanceSupport === "Support: Active") {
                supportData = item;
              } else if (item?.resistanceSupport === "Resistance: Active") {
                resistanceData = item;
              }
            });

            setSupport(supportData);
            setResistance(resistanceData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [date]); // 🔥 Added date as dependency


  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const groupByProduct = (data) => {
    const groupedData = {};

    data.forEach((item) => {
      const product = item?.options?.Request?.Product;
      const key = `${product}-${item.timestamp}`; // Ensure uniqueness with timestamp

      if (groupedData[product]) {
        groupedData[product].count += 1; // Increase count for duplicate
      } else {
        groupedData[product] = { ...item, count: 1 }; // Store first occurrence
      }
    });

    return Object.values(groupedData);
  };
const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
};




  // Filter data based on search query
  const filteredSupportData = data.filter(
    (item) =>
      item?.resistanceSupport === "Support: Active" &&
      item?.options?.Request?.Product.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredResistanceData = data.filter(
    (item) =>
      item?.resistanceSupport === "Resistance: Active" &&
      item?.options?.Request?.Product.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Apply this function before rendering
  const groupedSupportData = groupByProduct(filteredSupportData);
  const groupedResistanceData = groupByProduct(filteredResistanceData);
  // Get current date in YYYY-MM-DD format
  const currentDate = new Date().toISOString().split("T")[0];
const getFormattedTime24 = (timestamp) => {
  const date = new Date(new Date(timestamp).getTime() - 5.5 * 60 * 60 * 1000); // Adjust for IST
  return date.toTimeString().slice(0, 5); // Returns "HH:mm"
};

  return (
    <section className="sr-stocks-section py-70">
      <div className="container-fluid">
        <div className="row justify-content-end">
          <div className="col-md-2">
            <input
              className="form-control"
              type="date"
              id="dateInput"
              value={date || currentDate} // Default to current date
              onChange={handleDateChange}
              style={{ width: "100%" }}
            />
          </div>

        </div>
        <ul className="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active site-btn" id="pills-support-tab" data-bs-toggle="pill" data-bs-target="#pills-support" type="button" role="tab" aria-controls="pills-support" aria-selected="true">
              Support
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link site-btn" id="pills-resistance-tab" data-bs-toggle="pill" data-bs-target="#pills-resistance" type="button" role="tab" aria-controls="pills-resistance" aria-selected="false">
              Resistance
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="pills-support" role="tabpanel" aria-labelledby="pills-support-tab">
            {support ? (
              <div className="row">
                <div className="col-md-12">
                  <div className="searchForm" style={{ textAlign: "center", marginBottom: "20px" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", border: "1px solid #ccc", borderRadius: "5px", padding: "5px 10px", background: "#fff" }}>
                      <i className="fa fa-search" aria-hidden="true"></i>
                      <input
                        type="text"
                        placeholder="Search for..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{
                          border: "none",
                          outline: "none",
                          fontSize: "16px",
                          width: "200px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="trends-stocks stocks-outer">
                    {/* <button type="button" className="green-btn site-btn mx-auto d-block" data-bs-toggle="collapse" data-bs-target="#trends-stocks-inner" aria-expanded="false" aria-controls="trends-stocks-inner">
                      Trend
                    </button> */}
                    <div className="trends-stocks-inner sr-stocks-inner" id="trends-stocks-inner">
                      {groupedSupportData.length > 0 ? (
                        groupedSupportData.map((stock, index) => (
                          <button key={index} className="stocks-box">
                            <h5 className="time">
                              {new Date(stock?.timestamp).toISOString().split("T")[0]}{" "}
                              {new Date(new Date(stock?.timestamp).getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </h5>
                            <h6>{stock?.options?.Request?.Product}&nbsp; <span className="bg-primary text-white px-2 rounded">{stock.count > 0 ? `${stock.count}` : ""}</span></h6>
                            <div className="flex justify-center mt-4 space-x-2">
                                <button
                                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50 transition"
                                onClick={() => {
                                  const date = formatDate(stock?.timestamp); 
                                  const time = getFormattedTime24(stock?.timestamp);
                                  const symbolToken = stock?.options?.Request?.Product;
                                
                                  // Save to localStorage if needed
                                  localStorage.setItem("stock", symbolToken);

                                  // Open /backtester with query parameters
                                  const url = `/backtester?date=${encodeURIComponent(date)}&time=${encodeURIComponent(time)}&symbolToken=${encodeURIComponent(symbolToken)}`;
                                  window.open(url, "_blank");
                                }}
                              >
                                Historical
                              </button>
                              <button
                                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50 transition"
                                onClick={() => {
                                  localStorage.setItem("stock", stock?.options?.Request?.Product);
                                  window.open("/optionchain", "_blank");
                                }}
                              >
                                Live Data
                              </button>

                            </div>
                          </button>
                        ))
                      ) : (
                        <p className="text-center">No matching support data found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-center">No active support data available.</p>
            )}
          </div>
          <div className="tab-pane fade" id="pills-resistance" role="tabpanel" aria-labelledby="pills-resistance-tab">
            {resistance ? (
              <div className="row">
                <div className="col-md-12">
                  <div className="searchForm" style={{ textAlign: "center", marginBottom: "20px" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", border: "1px solid #ccc", borderRadius: "5px", padding: "5px 10px", background: "#fff" }}>
                      <i className="fa fa-search" aria-hidden="true"></i>
                      <input
                        type="text"
                        placeholder="Search for..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{
                          border: "none",
                          outline: "none",
                          fontSize: "16px",
                          width: "200px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="trends-stocks stocks-outer">
                    {/* <button type="button" className="green-btn site-btn mx-auto d-block" data-bs-toggle="collapse" data-bs-target="#trends-stocks-inner" aria-expanded="false" aria-controls="trends-stocks-inner">
                      Trend
                    </button> */}
                    <div className="trends-stocks-inner sr-stocks-inner " id="trends-stocks-inner">
                      {groupedResistanceData.length > 0 ? (
                        groupedResistanceData.map((stock, index) => (
                          <button key={index} className="stocks-box">
                            <h5 className="time">
                              {new Date(stock?.timestamp).toISOString().split("T")[0]}{" "}
                              {new Date(new Date(stock?.timestamp).getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </h5>
                            <h6>{stock?.options?.Request?.Product}&nbsp;<span className="bg-danger text-white px-2 rounded">{stock.count > 0 ? `${stock.count}` : ""}</span></h6>
                            <div className="flex justify-center mt-4 space-x-2">
                              <button
                                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50 transition"
                                onClick={() => {
                                  const date = formatDate(stock?.timestamp); 
                                  const time = getFormattedTime24(stock?.timestamp);
                                  const symbolToken = stock?.options?.Request?.Product;
                                
                                  // Save to localStorage if needed
                                  localStorage.setItem("stock", symbolToken);

                                  // Open /backtester with query parameters
                                  const url = `/backtester?date=${encodeURIComponent(date)}&time=${encodeURIComponent(time)}&symbolToken=${encodeURIComponent(symbolToken)}`;
                                  window.open(url, "_blank");
                                }}
                              >
                                Historical
                              </button>

                              <button
                                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50 transition"
                                onClick={() => {
                                  localStorage.setItem("stock", stock?.options?.Request?.Product);
                                  window.open("/optionchain", "_blank");
                                }}
                              >
                                Live Data
                              </button>

                            </div>
                          </button>
                        ))
                      ) : (
                        <p className="text-center">No matching resistance data found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-center">No active resistance data available.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HotOption;
